<template>
  <div class="tariff-card" :class="{'card-disabled' : !cardData.canChange, 'featured featured-green': isOriginalTariff && cardData.remainingDays >= 0}">
    <p class="card-notice" v-if="isOriginalTariff && cardData.remainingDays >= 0">
      <template v-if="cardData.canChange">
        {{ $t('changeTariff.canSwitchBackLabel') }}
      </template>
      <template v-else>
        {{ $t('changeTariff.noSwitchBackLabel', { count: cardData.remainingDays >= 0 ? cardData.remainingDays : '90' }) }}
      </template>
    </p>
    <div class="single-card-wrapper">
      <div class="card-header">
        <h4 class="title">
          {{ cardData.name }}
        </h4>
        <button class="info-button" @click="emitInfoClick">
          <img src="/assets/images/tooltip-info-16.png"
               alt="info-icon">
        </button>
      </div>
      <div class="card-body">
        <template v-if="cardData.productSpecCharacteristicValues && cardData.productSpecCharacteristicValues.length">
          <div v-for="(feature, idx) in cardData.productSpecCharacteristicValues"
               :key="'feature'+idx+compId"
               class="feature">
            <img :src="feature.icon.url" alt=""/>
            <p class="description">{{ feature.description }} <span>{{ feature.characteristicName }}</span></p>
          </div>
        </template>
      </div>
      <div class="card-price">
        <p class="price">
          {{ cardData.price.formattedValue }} <span>{{ $t('changeTariff.currency') }}</span>
        </p>
      </div>
      <div class="card-footer" :class="{'overline' : cardData.currentTariff}">
        <p v-if="cardData.currentTariff">{{ $t('changeTariff.currentTariff') }}</p>
        <base-button v-else
                     variant="primary"
                     size="small"
                     class="change-tariff-button"
                     :disabled="$props.disabled || !cardData.canChange"
                     @click="emitChangeEvent(cardData.canChange)">
          {{ $t('changeTariff.changeTariffLabel') }}
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tariff-card',
  props: {
    cardData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: Boolean
  },
  computed: {
    compId () {
      return this._uid
    },
    isOriginalTariff () {
      return this.$props.cardData.originalTariff && !this.$props.cardData.currentTariff
    }
  },
  methods: {
    emitChangeEvent (allowed = false) {
      if (!allowed) return
      this.$emit('change-tariff')
    },
    emitInfoClick () {
      this.$emit('open-info')
    }
  }
}
</script>

<style scoped lang="scss" src="./styles/tariff-card.scss"></style>
